import { Component, Input } from "@angular/core";
import './stacked-probe-reading.component.scss';
export interface IStackedProbeReadingData {
    probeName?: string;
    temperature?: string;
    outOfBounds?: boolean;
    outOfDate?: boolean;
    lastUpdated?: string;
}

@Component({
    selector: 'stacked-probe-reading',
    template: require('./stacked-probe-reading.component.html')
})
export class StackedProbeReadingComponent {
    @Input() data: IStackedProbeReadingData;

    constructor() { }
}
